<template>
  <div id="HomePage">
    <!-- 轮播图 -->
    <div id="swiper" class="container-fuild">
      <div class="swiper-container banner-swiper">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in slideshowList"
            :key="index"
          >
            <!-- <img class="swiper-lazy" :src="item.img" alt="轮播图" />
            <div class="swiper-lazy-preloader"></div> -->
            <img :src="item.imgpath" alt="轮播图" />
            <div></div>

            <div class="swiper-slide-title">
              <h1>{{ item.title }}</h1>
              <div v-html="item.detail"></div>
            </div>
          </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>

        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </div>
    </div>
    <!-- 首页-产品中心-->
    <div
      id="bigData"
      class="container-fuild"
      v-for="(item, index) in productList"
      :key="index"
    >
      <div class="row bigData-container">
        <div class="col-xs-12 col-sm-12 col-md-6 wow zoomIn">
          <img
            class="img-responsive"
            style="width: 600px"
            :src="item.imgpath"
            alt="产品中心"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6">
          <h2 class="bigData-title">
            {{ item.title }}
          </h2>
          <div
            style="font-size: 18px; color: #888888; line-height: 42px"
            v-html="item.detail"
          ></div>
          <!-- <p style="font-size:18px;color:#888888;line-height:42px">{{ item.detail }}</p> -->
          <a href="#" class="btn btn-lg btn-block btn-info">了解详情</a>
        </div>
      </div>
    </div>
    <!-- 客户评价 -->
    <div id="customer" class="container-fuild">
      <div class="container customer-container">
        <h3 class="text-center">客户评价</h3>
        <div
          class="swiper-container customer-swiper hidden-xs"
          style="padding-left: 30px; padding-right: 30px"
        >
          <div class="swiper-wrapper">
            <div
              class="swiper-slide customer-block"
              v-for="(item, index) in customerEvaluationList"
              :key="index"
            >
              <div class="customer-logo">
                <img class="center-block" :src="item.imgpath" alt="logo" />
              </div>
              <div class="customer-yh">
                <img src="@/assets/img/yinhao.png" alt="引号" />
              </div>
              <!-- <div style="height:130px"
                   class="customer-content1">
                <small>{{item.detail}}</small>
              </div> -->
              <div style="height: 130px" class="customer-content1">
                <small v-html="item.detail" class="customer-content1"></small>
              </div>

              <div class="customer-content2">{{ item.title }}</div>
            </div>
          </div>
          <!-- 如果需要导航按钮 -->
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
        <div class="row visible-xs customer-block">
          <div
            class="col-xs-12"
            v-for="(item, index) in customerEvaluationList"
            :key="index"
          >
            <div class="customer-logo">
              <img class="center-block" :src="item.imgpath" alt="logo" />
            </div>
            <div class="customer-yh">
              <img src="@/assets/img/yinhao.png" alt="引号" />
            </div>
            <!-- <div class="customer-content1">
              <small>{{item.detail}}</small>
            </div> -->
            <div v-html="item.detail"></div>
            <div class="customer-content2">
              <small>{{ item.title }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 为什么选择我们 -->
    <div id="whyChooseUs" class="conatiner-fuild">
      <div class="container">
        <div class="whyChooseUs-title text-center">
          <h3>核心优势</h3>
        </div>
        <div class="row">
          <div
            class="col-xs-12 col-sm-6 col-md-3 server-wrapper"
            v-for="(item, index) in coreAdvantageList"
            :key="index"
          >
            <div
              class="server-block wow slideInUp"
              onmouseenter="this.style.color='#fff';this.style.backgroundColor='#28f'"
              onmouseleave="this.style.color='#333';this.style.borderColor='#ccc';this.style.backgroundColor='#fff'"
            >
              <p class="text-center">{{ item.title }}</p>
              <!-- <div class="text-center"
                   style="height:130px"
                   v-html="item.detail"></div> -->
              <div
                class="text-center"
                style="height: 130px"
                v-html="item.detail"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import { WOW } from "wowjs";
export default {
  name: "HomePage",
  data() {
    return {
      total: 0,
      pageNo: 1,
      pageSize: 100,
      rawData: [],
      serviceList: [],
      //轮播图数据
      slideshowList: [
        {
          id: "06fa401dd3b44e1782b29d5cc1804933",
          title: "里数2024春季校园招聘",
          subhead: "",
          imgpath:
            "https://leosue-cms.oss-cn-beijing.aliyuncs.com/images/20240304/113109bf305043cfa5b881ac4a995734微信图片_20240304151418.png",
          type: "轮播图",
          detail: "<p>职位覆盖上海、北京、深圳，暑假实习正式启动</p>",
          creator: null,
          creationTime: "2023-05-19 13:26:06",
          sort: null,
        },
        {
          id: "0c237d91ef0b4672b09a98568471f761",
          title: "里数智能制造与工业互联网平台",
          subhead: "",
          imgpath:
            "https://leosue-cms.oss-cn-beijing.aliyuncs.com/images/20240304/113109bf305043cfa5b881ac4a995734微信图片_20240304151418.png",
          type: "轮播图",
          detail: "<p>助力制造企业降本增效</p>",
          creator: null,
          creationTime: "2023-05-19 13:23:53",
          sort: null,
        },
        {
          id: "ffbd58c75d9b4a35a494bb431093f85e",
          title: "里数智慧医疗与大健康方案",
          subhead: "",
          imgpath:
            "https://leosue-cms.oss-cn-beijing.aliyuncs.com/images/20240304/113109bf305043cfa5b881ac4a995734微信图片_20240304151418.png",
          type: "轮播图",
          detail: "<p>医疗人工智能、数据驱动管理，以病人为中心的新时代</p>",
          creator: null,
          creationTime: "2023-05-19 13:22:11",
          sort: null,
        },
      ],
      //产品中心数据
      productList: [
        {
          id: "78b7fd0e4cc6409ab8a50372d00f28a8",
          title: "企业资源计划(ERP)",
          subhead: "",
          imgpath:
            "https://leosue-cms.oss-cn-beijing.aliyuncs.com/images/20240304/01a8f6b855ff481ab57fceb957b77e3b微信图片_20240304154338.png",
          type: "首页产品",
          detail:
            '<p><font size="4">• 供应链规划：根据市场需求和企业资源，制定战略规划和运营计划<br/></font></p><p><font size="4">• 订单管理：管理客户订单的接收、处理和交付，确保订单的准时交付</font></p><p><font size="4">• 库存管理：实时监控和管理库存的数量、位置和状态</font></p><p><font size="4">• 运输管理：优化运输路线和运输方式，降低运输成本和提高运输效率</font></p>',
          creator: null,
          creationTime: "2023-05-19 13:34:31",
          sort: null,
        },
        {
          id: "614d396851ca471dad0ad47285cd046a",
          title: "智慧医院一体化平台",
          subhead: "",
          imgpath:
            "https://leosue-cms.oss-cn-beijing.aliyuncs.com/images/20240304/77dfddd7a6e843488893a926a6a44b29微信图片_20240304175122(1).png",
          type: "首页产品",
          detail:
            '<p><font size="4">• HIS功能和接口：为各医院提供包含全部常规功能的HIS系统</font></p><p><font size="4">• 官网与APP：助力新建医院信息建设和宣传推广敏捷化</font></p><p><font size="4">• 业务打通：打通互联网医院和院内各系统业务流转</font></p><p><font size="4">• 集团化管控：统一并规范各医院临床、科研、教学、办公、运营等数据</font></p>',
          creator: null,
          creationTime: "2023-05-19 13:32:45",
          sort: null,
        },
      ],
      //客户评价数据
      customerEvaluationList: [
        {
          id: "b3ec4e1032714170aa8da74d21d7f62e",
          title: "中国高端女装服饰领域某头部企业",
          subhead: "",
          imgpath:
            "https://leosue-cms.oss-cn-beijing.aliyuncs.com/images/20230602/d0ce7e37259f4917a8b664ba4f3b03f05f01aa3d-9ade-4fb6-981b-00013475dba1.png",
          type: "客户评价",
          detail:
            "<p>以数字化驱动智能生产线按需制造再交付顾客的新制造。实现以销售订单驱动的多款式、小批量、多批次的时尚行业敏捷供应链，实现全渠道定制从订单、研发、生产、物流的智能化全流程，依托顾容大数据实现商品企划、产品研发、生产的智能化全流程。</p>",
          creator: null,
          creationTime: "2023-05-19 13:59:17",
          sort: null,
        },
        {
          id: "14982296c4cf4e369991814908f3cf42",
          title: "中国某顶尖的手袋鞋履时尚配饰集团",
          subhead: "",
          imgpath:
            "https://leosue-cms.oss-cn-beijing.aliyuncs.com/images/20230602/98f69ed6e1404807a3bd299e5bc92ef37b843226-371a-469e-be85-0ae730216633.png",
          type: "客户评价",
          detail:
            "<p>利用人工智能等技术手段对制造环节进行数字化转型，皮具行业首个数字化云服务体系架构的智能车间、它的核心是柔性供应链，助推C2M反向定制加速落地、这是公司全面数字化转型中重要的部署，先从供应链数宇化开始<br/>打通时尚配饰产业的全链路转型。</p>",
          creator: null,
          creationTime: "2023-05-19 13:57:03",
          sort: null,
        },
        {
          id: "c834ac744d40434e80e08ad8aa01bf4d",
          title: "国际某时尚及生活方式奢侈品牌",
          subhead: "",
          imgpath:
            "https://leosue-cms.oss-cn-beijing.aliyuncs.com/images/20230602/b9715ab6c859496abc4bfcca52e957362794af55-be42-46a8-acd8-a85aff29c3bc.png",
          type: "客户评价",
          detail:
            "<p>在数字化浪潮全面席卷而至的背景下，线上和线下的融合已经成为必然。购物中心、实体门店都在探索数字化，而数字化不仅仅意味着零售渠道的拓展，也意味着更为庞大的会员数量、更为高效的经营方式。奢侈品在新零售和数字化布局上有着越来越强的掌控力。</p>",
          creator: null,
          creationTime: "2023-05-19 13:54:04",
          sort: null,
        },
        {
          id: "cb62c9cb547d4d749fddd8269afd43ad",
          title: "中国高端男装服饰领域某头部企业",
          subhead: "",
          imgpath:
            "https://leosue-cms.oss-cn-beijing.aliyuncs.com/images/20230602/e60d25a6cd9c4e509fda419dd70404cb3ffa0d66-52ba-45a7-936b-98ce5e78897e.png",
          type: "客户评价",
          detail:
            "<p>项目的成功实施扩大了私人定制市场份额，降低管理成本、节约运输费用、并能提高工作效率、产品质量、客户满意率和市场预测的准确率，项目实现了绿色制造。实现C2B、 C2M模式的转型升级创造颠覆性的新商业模式，满足了消费者个性化时尚化的需求。</p>",
          creator: null,
          creationTime: "2023-05-19 13:50:09",
          sort: null,
        },
      ],
      //核心优势
      coreAdvantageList: [
        {
          id: "963636762e4348a29502dc3788c9308d",
          title: "强大的本土实施能力",
          subhead: "",
          imgpath: "",
          type: "核心优势",
          detail:
            "<p>采用国际前沿开发技术、研发模式和本土化落地服务体系，改善行业中因传统研发模式限制而造成系统升级困难、功能繁琐、技术落后等弊病，减少企业实施成本和风险。<br/></p>",
          creator: null,
          creationTime: "2023-05-19 14:03:23",
          sort: null,
        },
        {
          id: "af327ae0e1d24b3fa4e24bf15fb1335d",
          title: "行业领先的标准化产品",
          subhead: "",
          imgpath: "",
          type: "核心优势",
          detail:
            "<p>基于强大底层架构和算法实力为制造行业提供标准化的行业解决方案，同时灵活快速算法服务满足企业个性需求，系统支持二次开发，深度贴合客户实际业务场景需求。<br/></p>",
          creator: null,
          creationTime: "2023-05-19 14:02:52",
          sort: null,
        },
        {
          id: "f66533fa26564b9e983bafdf4b15401e",
          title: "深耕制造行业经验",
          subhead: "",
          imgpath: "",
          type: "核心优势",
          detail:
            "<p>深耕制造行业场景需求，十年以上深度制造业业务积累，来自世界500强制造行业的成功实施方案、优化及模拟技术，深度赋能制造场景需求，实现客户企业成功落地。<br/></p>",
          creator: null,
          creationTime: "2023-05-19 14:02:17",
          sort: null,
        },
        {
          id: "38f40b70b033490a9908e185f5171998",
          title: "国内顶尖算法技术",
          subhead: "",
          imgpath: "",
          type: "核心优势",
          detail:
            "<p>掌握全球顶尖运筹优化技术和人工智能算法，团队成员均来自中国顶级高校，具备自主研发APS技术能力，为复杂的生产和供应问题提供优化解决方案。<br/></p>",
          creator: null,
          creationTime: "2023-05-19 14:01:32",
          sort: null,
        },
      ],
    };
  },
  mounted() {
    // this.getSlideshow();
    this.getCustomerEvaluation();
  },
  created() {
    // this.getProduct();
    // this.getCoreAdvantage();
  },
  methods: {
    // //获取轮播图方法
    // getSlideshow () {
    //   this.http({
    //     method: "post",
    //     url: "/cms/api/Journalismfront/page",
    //     data: {
    //       pageNo: this.pageNo,
    //       pageSize: this.pageSize,
    //       type: "轮播图",
    //     },
    //   }).then((res) => {
    //     if (res.data.code == "200") {
    //       this.rawData = res.data.data.list;
    //       var newData = this.rawData.map(function (item, index) {
    //         return {
    //           id: item.id,
    //           title: item.title,
    //           eng_title: item.subhead,
    //           detail: item.detail,
    //           img: item.imgpath,
    //         };
    //       });
    //       this.slideshowList = newData;
    //     }
    //   });
    // },
    //获取产品中心方法
    // getProduct () {
    //   this.http({
    //     method: "post",
    //     url: "/cms/api/Journalismfront/page",
    //     data: {
    //       pageNo: this.pageNo,
    //       pageSize: this.pageSize,
    //       type: "首页产品",
    //     },
    //   }).then((res) => {
    //     if (res.data.code == "200") {
    //       this.rawData = res.data.data.list;
    //       var newData = this.rawData.map(function (item, index) {
    //         return {
    //           id: item.id,
    //           title: item.title,
    //           eng_title: item.subhead,
    //           detail: item.detail,
    //           img: item.imgpath,
    //         };
    //       });
    //       this.productList = newData;
    //     }
    //   });
    // },
    //获取客户评价方法
    getCustomerEvaluation() {
      this.$nextTick(() => {
        this.swiperInit();
      });
    },
    // //获取核心优势方法
    // getCoreAdvantage () {
    //   this.http({
    //     method: "post",
    //     url: "/cms/api/Journalismfront/page",
    //     data: {
    //       pageNo: this.pageNo,
    //       pageSize: this.pageSize,
    //       type: "核心优势",
    //     },
    //   }).then((res) => {
    //     if (res.data.code == "200") {
    //       this.rawData = res.data.data.list;
    //       var newData = this.rawData.map(function (item, index) {
    //         return {
    //           id: item.id,
    //           title: item.title,
    //           eng_title: item.subhead,
    //           detail: item.detail,
    //           img: item.imgpath,
    //         };
    //       });
    //       this.coreAdvantageList = newData;
    //     }
    //   });
    // },

    // 轮播图初始化
    swiperInit() {
      /* banner-swiper */
      new Swiper(".banner-swiper", {
        loop: false, // 循环模式选项
        effect: "fade",
        //自动播放
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 如果需要分页器
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        // 延迟加载
        // lazy: {
        //   loadPrevNext: true,
        // },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
      });
      /* customer-swiper */
      new Swiper(".customer-swiper", {
        loop: true, // 循环模式选项
        slidesPerView: 3,
        //自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
      });
      /* wowjs动画 */
      var wow = new WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 0,
        mobile: true,
        live: false,
      });
      wow.init();
    },
  },
};
</script>
<style scoped>
/* .banner-button-prev {
  background-image: url("../assets/img/bannerPrev.png");
}
.banner-button-next {
  background-image: url("../assets/img/bannerNext.png");
} */
.swiper-button-prev {
  background-image: url("../assets/img/prev.png");
}
.swiper-button-next {
  background-image: url("../assets/img/next.png");
}
.btn-info {
  background-color: #25579f;
}
/* 整体盒子 */
#HomePage {
  width: 100%;
}

/* 轮播图 */
#swiper {
  height: 600px;
}
#swiper .banner-swiper {
  width: 100%;
  height: 100%;
}
#swiper .banner-swiper .swiper-slide img {
  width: 100%;
  height: 100%;
}
#swiper .banner-swiper .swiper-slide {
  position: relative;
}
#swiper .banner-swiper .swiper-slide-title {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999999999;
  width: 100%;
  height: 100%;
  color: #fff;
  background: rgba(7, 42, 147, 0.3);
  text-align: center;
  line-height: 80px;
}
#swiper .banner-swiper .swiper-slide-title > h1 {
  font-size: 30px;
  margin-top: 15%;
}
#swiper .banner-swiper .swiper-slide-title > p {
  font-size: 18px;
  margin-top: 1%;
  font-weight: 700;
}
/* 医药大数据系统*/
#bigData {
  padding: 100px;
  transition: all ease 0.6s;
  box-sizing: border-box;
}
#bigData .bigData-title {
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
}
#bigData p {
  font-size: 14px;
  color: #333;
  line-height: 2rem;
}
#bigData .bigData-device {
  margin: 50px 0 20px;
}

/* 您身边的IT专家 */
#contactUs {
  color: #fff;
  height: 400px;
  background: url("../assets/img/contact_us_bg.jpg") 0 0 no-repeat;
  background-size: 100% 100%;
  transition: all ease 0.6s;
}
#contactUs .contactUs-container {
  padding-top: 50px;
}
#contactUs .contactUs-container button {
  width: 300px;
  height: 50px;
  margin-top: 40px;
}
#contactUs .contactUs-container .contactUs-contactWay span {
  display: inline-block;
  width: 48px;
  height: 48px;
  margin: 30px;
}
#contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(1) {
  background: url("../assets/img/weixin.png") 0 0 no-repeat;
  background-size: 100% 100%;
}
#contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(2) {
  background: url("../assets/img/weibo.png") 0 0 no-repeat;
  background-size: 100% 100%;
}
#contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(3) {
  background: url("../assets/img/twitter.png") 0 0 no-repeat;
  background-size: 100% 100%;
}

/* 客户评价 */
#customer {
  padding: 50px 0;
  box-sizing: border-box;
  background: #efefef;
  transition: all ease 0.6s;
}
#customer .customer-title {
  font-size: 30px;
  color: rgb(102, 102, 102);
  margin: 0 0 30px;
}
#customer .customer-block {
  background: #fff;
  padding: 30px;
}
#customer .customer-logo img {
  width: 94px;
  height: 94px;
  /* border: 1px solid #ccc; */
}
#customer .customer-yh img {
  width: 34px;
  height: 34px;
}
#customer .customer-content1 {
  padding-bottom: 20px;
  border-bottom: 1px solid #25579f;
}
#customer .customer-content2 {
  padding-top: 20px;
}
/* 为什么选择我们 */
#whyChooseUs {
  padding: 100px;
}
#whyChooseUs .whyChooseUs-title {
  margin-bottom: 50px;
}
#whyChooseUs .whyChooseUs-title p:nth-of-type(1) {
  font-size: 30px;
  font-weight: 500;
}
#whyChooseUs .whyChooseUs-title p:nth-of-type(2) {
  font-size: 14px;
}
#whyChooseUs .server-block {
  padding: 50px 20px;
  border: 1px solid #ccc;
  /* border-bottom: 5px solid #ccc; */
}
#whyChooseUs .server-block img {
  width: 48px;
  height: 48px;
}
#whyChooseUs .server-block > p {
  font-size: 20px;
  margin: 30px 0;
}
#whyChooseUs .server-block > div {
  color: #ccc;
}
/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  #swiper {
    height: 200px;
  }
  #bigData {
    padding: 30px;
  }
  #bigData .bigData-title {
    font-size: 20px;
  }
  #bigData .bigData-device {
    font-size: 20px;
    margin: 10px 0 10px;
  }
  #contactUs {
    height: 200px;
    transition: all ease 0.6s;
  }
  #contactUs .contactUs-container {
    padding-top: 0;
  }
  #contactUs .contactUs-container h1 {
    font-size: 25px;
  }
  #contactUs .contactUs-container h3 {
    font-size: 18px;
  }
  #contactUs .contactUs-container button {
    width: 200px;
    height: 30px;
    margin-top: 20px;
  }
  #contactUs .contactUs-container .contactUs-contactWay span {
    display: inline-block;
    width: 28px;
    height: 28px;
    margin: 10px;
  }
  #customer {
    padding: 30px 0;
    box-sizing: border-box;
    background: #fff;
  }
  #customer .customer-title {
    font-size: 16px;
    font-weight: bold;
  }
  #customer .customer-logo img {
    width: 48px;
    height: 48px;
  }
  #customer .customer-block {
    padding: 30px;
  }
  #customer .customer-block > div {
    padding: 30px 0;
  }
  #whyChooseUs {
    padding: 20px 0;
    transition: all ease 0.6s;
  }
  #whyChooseUs .whyChooseUs-title p:nth-of-type(1) {
    font-size: 20px;
    font-weight: 700;
  }
  #whyChooseUs .whyChooseUs-title p:nth-of-type(2) {
    font-size: 12px;
  }
  #whyChooseUs .server-block {
    /* padding: 50px 0; */
    margin: 10px;
    border: 1px solid #ccc;
    /* border-bottom: 5px solid #ccc; */
  }
  #whyChooseUs .server-block img {
    width: 48px;
    height: 48px;
  }
  #whyChooseUs .server-block > p {
    font-size: 20px;
    margin: 30px 0;
  }
  #whyChooseUs .server-block > div {
    color: #ccc;
  }
}

/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {
  #swiper {
    height: 400px;
  }
  #bigData {
    padding: 60px;
  }
  #bigData .bigData-title {
    font-size: 30px;
  }
  #bigData .bigData-device {
    font-size: 30px;
    margin: 30px 0 15px;
  }
  #contactUs {
    height: 300px;
  }
  #contactUs .contactUs-container {
    padding-top: 50px;
  }
  #contactUs .contactUs-container h1 {
    font-size: 30px;
  }
  #contactUs .contactUs-container h3 {
    font-size: 20px;
  }
  #contactUs .contactUs-container button {
    width: 300px;
    height: 50px;
    margin-top: 30px;
  }
  #contactUs .contactUs-container .contactUs-contactWay span {
    display: inline-block;
    width: 32px;
    height: 32px;
    margin: 15px;
  }
  #customer .customer-title {
    font-size: 24px;
  }
  #whyChooseUs {
    padding: 20px 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/view/HomePage.vue